<header role="banner" class="wrapper--white">
  <div class="hero">
    <div class="hero__text">
      <h1 role="heading" class="hero__title">
        <span class="line-break">Je découvre les aides</span>
        <span class="line-break">auxquelles j&apos;ai droit</span>
        <span class="highlight--emphasis">en moins de 5 minutes.</span>
      </h1>

      <div class="hero__content">
        <p>
          Avant de démarrer la simulation de vos aides via l&apos;outil la boussole des aides, pensez à vous munir de
          vos ressources et de celles de vos parents si vous êtes encore à leur charge.
        </p>
        <a
          href="https://mes-aides.1jeune1solution.beta.gouv.fr/simulation"
          aria-label="Lien vers le site mes aides un jeune une solution"
          class="btn"
          (click)="
            trackEvent({
              category: 'Mes Aides',
              action: 'Click Start Simulation',
              type: 'navigation'
            })
          "
          >Je commence</a
        >
      </div>
    </div>
    <div
      class="hero__background"
      *ngIf="(isMobileOrTablet$ | async) === false && (isTabletLandscape$ | async) === false"
    >
      <img src="/assets/images/hero/triangle-white.svg" alt="Triangle blanc" class="hero__triangle-white" />

      <picture *ngIf="(isIpadPro$ | async) === false">
        <source
          srcset="
            /assets/images/hero/man_2.webp,
            /assets/images/hero/man_2@2x.webp 2x,
            /assets/images/hero/man_2@3x.webp 3x,
            /assets/images/hero/man_2@4x.webp 4x
          "
          type="image/webp"
        />
        <source
          srcset="
            /assets/images/hero/man_2.png,
            /assets/images/hero/man_2@2x.png 2x,
            /assets/images/hero/man_2@3x.png 3x,
            /assets/images/hero/man_2@4x.png 4x
          "
        />
        <img src="/assets/images/hero/man_2.png" class="hero__hero1" alt="Mes aides Hero Un" loading="lazy" />
      </picture>

      <picture>
        <source
          srcset="
            /assets/images/hero/woman_1.webp,
            /assets/images/hero/woman_1@2x.webp 2x,
            /assets/images/hero/woman_1@3x.webp 3x,
            /assets/images/hero/woman_1@4x.webp 4x
          "
          type="image/webp"
        />
        <source
          srcset="
            /assets/images/hero/woman_1.png,
            /assets/images/hero/woman_1@2x.png 2x,
            /assets/images/hero/woman_1@3x.png 3x,
            /assets/images/hero/woman_1@4x.png 4x
          "
        />
        <img src="/assets/images/hero/woman_1.png" class="hero__hero2" alt="Mes aides Hero Deux" loading="lazy" />
      </picture>
    </div>
  </div>
</header>
